export const BLOCKED_ENTITIES = ['goal', 'task', 'activity', 'event'] as const;
export const BLOCKER_TYPES = ['goal', 'task', 'event', 'activity', 'time'] as const;
export const BLOCKER_MODES = ['hard', 'soft'] as const;

export type BlockedEntity = (typeof BLOCKED_ENTITIES)[number];
export type BlockerType = (typeof BLOCKER_TYPES)[number];
export type BlockerMode = (typeof BLOCKER_MODES)[number];

export interface Blocker {
  id: number;
  blocked_entity: BlockedEntity;
  blocked_id: number;
  blocked_event_status: string | null;
  blocker_type: BlockerType;
  blocker_id: number | null;
  blocker_event_status: string | null;
  scheduled_time: string | null;
  mode: BlockerMode;
  created_at: string;
}

export interface CreateBlockerDto {
  blocked_entity: BlockedEntity;
  blocked_id: number;
  blocked_event_status?: string;
  blocker_type: BlockerType;
  blocker_id?: number;
  blocker_event_status?: string;
  scheduled_time?: string;
  mode?: BlockerMode;
}
